import { apiConcurso } from './cliente';

// Enquadramentos — player-facing (Produtor)

export const obterBootstrapEnquadramento = (concursoId) =>
  apiConcurso.get(`/api/v1/enquadramentos/${concursoId}/bootstrap`);

export const queryEnquadramento = (concursoId, data) =>
  apiConcurso.post(`/api/v1/enquadramentos/${concursoId}/query`, data);

export const finalizarEnquadramento = (data) => apiConcurso.post('/api/v1/enquadramentos/finalizar', data);
